import DevolucionesProveedoresService from "@/services/inventario/DevolucionesProveedoresService";

const fetch = (context, params) => {
  return DevolucionesProveedoresService.fetch(params)
    .then(res => {
      context.commit('DEVOLUCION_PROVEEDOR', res.data);
    });
};

export default {
  fetch,
};